import { App } from "vue"

export function setUnmountListener(el: HTMLElement, app: App<Element>) {
  el.addEventListener("parmonic_unmount", () => app.unmount())
}
